// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__28IkA","item":"styles_item__cHhsD","active":"styles_active__vMD04","border":"styles_border__ylFXJ","label":"styles_label__pX3_N"};